import {Carousel} from "@mantine/carousel";
import {Box, Flex, Image, Text} from "@mantine/core";
import { useRef } from '@wordpress/element';
import Autoplay from 'embla-carousel-autoplay';
import CategoryPlaceholderImage from '../../../../../assets/images/category_placeholder.png';


const _Category3 = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Carousel
                slideSize={75}
                loop
                align="start"
                withControls={false}
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={autoplay.current.reset}

            >
                {
                    component?.items?.map((item, index) => (
                        <Carousel.Slide key={item.id}>
                            <Flex
                                align="center"
                                justify="center"
                                direction="column"
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                style={{
                                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,

                                }}
                            >
                                <Image
                                    src={item.image_url}
                                    fallbackSrc={CategoryPlaceholderImage}
                                    alt={item.name}
                                    radius={component?.customize_styles?.image_decoration?.radius}
                                    // bg={component?.customize_styles?.image_decoration?.color}
                                    w={50}

                                />
                                <Text
                                    c={component?.customize_styles?.name_text_decoration?.color}
                                    fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                    fz={component?.customize_styles?.name_text_decoration?.font_size}
                                    fs={component?.customize_styles?.name_text_decoration?.font_style}
                                    lineClamp={1}
                                    translate="yes"
                                    ta="center"
                                >
                                    {item?.name}
                                </Text>
                            </Flex>
                        </Carousel.Slide>
                    ))
                }
            </Carousel>
        </Box>
    )
}
export default _Category3;